import { WebPlugin } from '@capacitor/core';
export class FileDownloadWeb extends WebPlugin {
    async download(options) {
        return options;
    }
}
//# sourceMappingURL=web.js.map